export default __webpack_public_path__ + "media/0f8f0c140d944e4f978f7464ffc4b9e0650b2d362e2889355f6afdf385760ed3.svg";